/** Tag colour for a job's quote validity (gitaumoses4/chukua#34) — same idiom as `DEADLINE_PRESSURE_LABELS`. */
export const QUOTE_VALIDITY_COLORS = { valid: 'default', expired: 'error' } as const;

/** "Valid until 12/31/2026" for a quote still within its date, "Expired" once past it — `formattedValidUntil` is already locale-formatted by the caller. */
export function quoteValidityLabel(expired: boolean, formattedValidUntil: string): string {
  return expired ? 'Expired' : `Valid until ${formattedValidUntil}`;
}
